module.exports = __webpack_public_path__ + "img/footer-text_460.6fc62dd9.png";